import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline"

import type { BatterySavingsSupportDto } from "~/api/dto/battery-arbitrage.dto"

import { batteryArbitrageReasonCopy } from "./battery-arbitrage-status"

export function TariffSavingsIndicator({
  hasGeneralizedRateScenario,
  support,
}: {
  hasGeneralizedRateScenario: boolean
  support: BatterySavingsSupportDto | undefined
}): JSX.Element {
  const label =
    support?.estimate === `personalized`
      ? `Personalized estimate available`
      : support?.estimate === `generalized`
        ? `Generalized estimate available`
        : support?.estimate === `unavailable`
          ? support.limitation === `rate_plan`
            ? `Unavailable for current inputs`
            : support.limitation === `provider`
              ? `Billing service unavailable`
              : `Needs usage or equipment inputs`
          : hasGeneralizedRateScenario
            ? `Generalized rate scenario`
            : `Not checked`
  const Icon =
    support?.estimate === `personalized` || support?.estimate === `generalized`
      ? CheckCircleIcon
      : support?.estimate === `unavailable`
        ? ExclamationTriangleIcon
        : hasGeneralizedRateScenario
          ? InformationCircleIcon
          : QuestionMarkCircleIcon
  return (
    <span
      title={
        support?.reason
          ? batteryArbitrageReasonCopy(support.reason).detail
          : undefined
      }
      className="inline-flex items-center gap-1.5 text-xs normal-case"
    >
      <Icon aria-hidden="true" className="size-4 shrink-0" />
      {label}
    </span>
  )
}
